module.exports = __webpack_public_path__ + "img/jm4.13c3dbee.png";